import React from "react";
import "./Loader.css";

// Blockchain-network loader: nodes connected by links with data pulses
// flowing along the spokes, the whole graph slowly rotating.
const R = 42, C = 60;
const ANGLES = [0, 60, 120, 180, 240, 300];
const NODES = ANGLES.map((a) => {
  const rad = (a * Math.PI) / 180;
  return { x: +(C + R * Math.cos(rad)).toFixed(2), y: +(C + R * Math.sin(rad)).toFixed(2) };
});

export default function Loader({ text = "Loading Smartcore Node network", fullscreen = true }) {
  return (
    <div className={fullscreen ? "loader-overlay" : "loader-inline"}>
      <div className="net-loader">
        <svg viewBox="0 0 120 120" width="128" height="128">
          <g className="net-spin">
            {/* hexagon perimeter links */}
            <polygon
              className="net-ring"
              points={NODES.map((n) => `${n.x},${n.y}`).join(" ")}
              fill="none"
            />
            {/* spokes with flowing data pulses */}
            {NODES.map((n, i) => (
              <line
                key={`s${i}`}
                className="net-spoke"
                x1={C} y1={C} x2={n.x} y2={n.y}
                style={{ animationDelay: `${i * 0.18}s` }}
              />
            ))}
            {/* outer nodes */}
            {NODES.map((n, i) => (
              <circle
                key={`n${i}`}
                className="net-node"
                cx={n.x} cy={n.y} r="6"
                style={{ animationDelay: `${i * 0.18}s` }}
              />
            ))}
          </g>
          {/* center block */}
          <circle className="net-core" cx={C} cy={C} r="9" />
        </svg>
      </div>
      <div className="loader-text">{text}<span className="ellipsis" /></div>
    </div>
  );
}
